import { useCallback } from 'react';
import { useDeviceType } from '@cian/ui-kit/responsive';
import {
  trackRequestForSaleClick,
  trackRequestForSaleIntoView,
  trackSendDemandRequestIntoView,
  trackSendDemandRequestClick,
} from '../tracking';
import { useSelector } from 'react-redux';
import { selectDemandRequest } from '../../../selectors/dataPayment';
import { EAction } from '../../../repositories/price-estimator/entities/estimation/CheckEstimationRequestExistsResponseSchema';

export const useTrackRealtorDemand = () => {
  const deviceType = useDeviceType();
  const { status } = useSelector(selectDemandRequest);

  const trackDemandViewed = useCallback(
    () => (status === EAction.SendRequest ? trackSendDemandRequestIntoView() : trackRequestForSaleIntoView()),
    [status],
  );

  const trackDemandClick = useCallback(
    () =>
      status === EAction.SendRequest ? trackSendDemandRequestClick(deviceType) : trackRequestForSaleClick(deviceType),
    [deviceType, status],
  );

  return {
    trackDemandViewed,
    trackDemandClick,
  };
};
